import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { fetchIntegrationTokens, generateIntegrationToken, revokeIntegrationToken } from './api'
import { GenerateInput } from './input/generate-input'
import { notification } from 'antd'
import { t } from 'i18next'

export function useIntegrationTokens() {
    return useQuery({
        queryFn: () => fetchIntegrationTokens(),
        queryKey: ['integration-tokens'],
    })
}

export function useGenerateIntegrationToken() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (input: GenerateInput) => generateIntegrationToken(input),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['integration-tokens'] })
            notification.success({
                message: t('Integration token generated'),
                description: t('The integration token has been generated successfully'),
            })
        },
    })
}

export function useRevokeIntegrationToken() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (tokenId: string) => revokeIntegrationToken(tokenId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['integration-tokens'] })
            notification.success({
                message: t('Integration token revoked'),
                description: t('The integration token has been revoked successfully'),
            })
        },
    })
}
